import { render } from "./XlsToggle.vue?vue&type=template&id=819633a4&scoped=true"
import script from "./XlsToggle.vue?vue&type=script&lang=js"
export * from "./XlsToggle.vue?vue&type=script&lang=js"

import "./XlsToggle.vue?vue&type=style&index=0&id=819633a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-819633a4"]])

export default __exports__